type CardFormScope = {
    number: string;
    cvc: number;
    expiry: string;
};

export class CreditCard {
    flipped: boolean;
    formName: string;
    holder: string;
    type: boolean | string;

    constructor(formName: string) {
        this.type = false;
        this.formName = formName;
    }

    detect() {
        const form = <ng.IScope & CardFormScope>angular.element('form[name="' + this.formName + '"]').scope();
        if (!form.number || form.number.length < 2) {
            return false;
        }
        let re = new RegExp("^4");
        if (form.number.match(re) !== null) {
            this.type = "Visa";
        }
        re = new RegExp("^5[1-5]");
        if (form.number.match(re) !== null) {
            this.type = "Mastercard";
        }
        re = new RegExp("^3[47]");
        if (form.number.match(re) !== null) {
            this.type = "AMEX";
        }
        re = new RegExp("^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)");
        if (form.number.match(re) !== null) {
            this.type = "Discover";
        }
    }

    number() {
        const form = <ng.IScope & CardFormScope>angular.element('form[name="' + this.formName + '"]').scope();
        if (form.number) {
            const cardNum = form.number.replace(' ', '');
            const parts = cardNum.match(/[\s\S]{1,4}/g) || [];
            return parts.join(' ');
        }
        return '';
    }

    expiry() {
        const form = <ng.IScope & CardFormScope>angular.element('form[name="' + this.formName + '"]').scope();
        return form.expiry;
    }

    cvc() {
        const form = <ng.IScope & CardFormScope>angular.element('form[name="' + this.formName + '"]').scope();
        return form.cvc;
    }
}



// WEBPACK FOOTER //
// ./_src/service_ui/billing/cardUtils.ts